import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: "",
  roleId: "",
};

const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setRoleId: (state, action) => {
      state.roleId = action.payload;
    },
  },
});

export const { setUserId, setRoleId } =
  userSlice.actions;
export default userSlice.reducer;
